module.exports = __webpack_public_path__ + "img/listePortage.598d557c.png";